/**
 * 订单列表 / 订单详情 / 团购详情 / 电影票 / 爆米花订单
 * 由原 src/router.js 原样搬移（顺序即路由匹配优先级，请勿调整）；
 * 仅把动态导入路径 './views/xxx.vue' 改为 '@/views/xxx.vue'（@ = src）。
 */
export default [
  {
    path: '/order_list',
    name: 'order_list',
    component: () =>
      import(
        /* webpackChunkName: "common" */
        '@/views/order/order_list.vue'
      ),
    meta: {
      title: '订单列表',
      isCommon: true,
      // 页面里有 activated/deactivated（从订单详情返回时刷新状态），缓存是设计意图。
      // 原先写在记录级不生效（App.vue 判定的是 $route.meta.keepAlive），这里移进 meta
      keepAlive: true
    }
  },
  {
    path: '/order/order_detail_v1',
    name: 'order_detail_v1',
    component: () =>
      import(
        /* webpackChunkName: "common" */
        '@/views/order/order_detail_v1.vue'
      ),
    meta: {
      title: '订单详情', // (实物订单)
      isCommon: true
    }
  },
  {
    path: '/order/order_detail',
    name: 'order_detail',
    component: () =>
      import(
        /* webpackChunkName: "common" */
        '@/views/order/order_detail.vue'
      ),
    meta: {
      title: '订单详情', //（虚拟订单）
      isCommon: true
    }
  },
  {
    path: '/order/group_detail',
    name: 'group_detail',
    component: () => import('@/views/order/group_detail.vue'),
    meta: {
      title: '订单详情', //(组合礼包)
      isCommon: true
    }
  },
  {
    path: '/order/movie_order',
    name: 'movie_order',
    component: () =>
      import(
        /* webpackChunkName: "common" */
        '@/views/order/movie_order.vue'
      ),
    meta: {
      title: '电影订单详情',
      isCommon: true
    }
  },
  {
    path: '/order/popcorn_order',
    name: 'popcorn_order',
    component: () =>
      import(
        /* webpackChunkName: "common" */
        '@/views/order/popcorn_order.vue'
      ),
    meta: {
      title: '爆米花订单详情',
      isCommon: true
    }
  }
];
